export const webhooksHeaders = [
  {
    field: 'radioButton',
    headerName: '',
    width: 68,
    disableColumnMenu: true,
    hideable: false,
    pinnable: false,
    sortable: false,
    resizable: false,
  },
  {
    field: 'name',
    headerName: 'Name',
    minWidth: 250,
    disableColumnMenu: true,
    hideable: false,
    pinnable: false,
    sortable: false,
    resizable: false,
    flex: 1,
  },
  {
    field: 'status',
    headerName: 'Status',
    minWidth: 140,
    disableColumnMenu: true,
    hideable: false,
    pinnable: false,
    sortable: false,
    resizable: false,
  },
  {
    field: 'updatedAt',
    headerName: 'Last updated',
    minWidth: 240,
    disableColumnMenu: true,
    hideable: false,
    pinnable: false,
    sortable: false,
    resizable: false,
  },
  {
    field: 'subscribedVehicles',
    headerName: 'Subscribed vehicle(s)',
    minWidth: 100,
    disableColumnMenu: true,
    hideable: false,
    pinnable: false,
    sortable: false,
    resizable: false,
    flex: 1,
  },
];

export const PAGE_SIZE = 10;
